import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

/*
* ! La meta desc et le schema ne fonctionnent qu'en prod 
* pour tester en local, il faut build puis utiliser serve
* -- npm run build
* -- serve -s build
*/

const langMeta = {
  fr: {
    title: "Location maison ou appartement en Sardaigne – Villa Pina & Paolo",
    description: "Découvrez notre villa de vacances à San Teodoro en Sardaigne : piscine, nature, confort et plage à proximité."
  },
  it: {
    title: "Affitto villa o appartamento in Sardegna – Villa Pina & Paolo",
    description: "Scopri la nostra villa vacanze a San Teodoro in Sardegna: piscina, natura, comfort e spiagge vicine."
  },
  en: {
    title: "Sardinia villa or apartment rental – Villa Pina & Paolo",
    description: "Book your holiday villa in San Teodoro, Sardinia. Pool, comfort, nature and beaches nearby."
  },
  de: {
    title: "Ferienhaus auf Sardinien mieten – Villa Pina & Paolo",
    description: "Ferienvilla in San Teodoro mit Pool, Natur und Stränden in der Nähe."
  },
  pt: {
    title: "Aluguel de villa ou apartamento na Sardenha – Villa Pina & Paolo",
    description: "Alugue sua casa de férias em San Teodoro, com piscina e natureza ao redor."
  },
  es: {
    title: "Alquiler de villa o apartamento en Cerdeña – Villa Pina & Paolo",
    description: "Disfruta de una villa en San Teodoro con piscina y cerca del mar."
  },
  ru: {
    title: "Аренда виллы или апартаментов на Сардинии – Villa Pina & Paolo",
    description: "Отдых в Сан-Теодоро: вилла с бассейном, комфорт и природа рядом."
  }
};

const seoPaths = {
  fr: "/fr/location-maison-appartement-sardaigne-san-teodoro",
  it: "/it/affitto-villa-appartamento-sardegna-san-teodoro",
  en: "/en/sardinia-villa-apartment-rental-san-teodoro",
  de: "/de/ferienhaus-sardinien-san-teodoro",
  pt: "/pt/aluguel-villa-sardenha-san-teodoro",
  es: "/es/alquiler-villa-sardinia-san-teodoro",
  ru: "/ru/arenda-villy-sardinija-san-teodoro"
};

const SEOHead = ({ lang }) => {
  const meta = langMeta[lang] || langMeta['it'];

  const baseUrl = 'https://www.villa-santeodoro.com';

  return (
    <Helmet>
      <html lang={lang} />
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />

      {/* hreflang links */}
      <link rel="alternate" href={`${baseUrl}/fr/location-maison-appartement-sardaigne-san-teodoro`} hreflang="fr" />
      <link rel="alternate" href={`${baseUrl}/it/affitto-villa-appartamento-sardegna-san-teodoro`} hreflang="it" />
      <link rel="alternate" href={`${baseUrl}/en/sardinia-villa-apartment-rental-san-teodoro`} hreflang="en" />
      <link rel="alternate" href={`${baseUrl}/de/ferienhaus-sardinien-san-teodoro`} hreflang="de" />
      <link rel="alternate" href={`${baseUrl}/pt/aluguel-villa-sardenha-san-teodoro`} hreflang="pt" />
      <link rel="alternate" href={`${baseUrl}/es/alquiler-villa-sardinia-san-teodoro`} hreflang="es" />
      <link rel="alternate" href={`${baseUrl}/ru/arenda-villy-sardinija-san-teodoro`} hreflang="ru" />
      <link rel="alternate" href={baseUrl} hreflang="x-default" />

      {/* Schema.org JSON-LD */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LodgingBusiness",
          "name": "Villa Pina & Paolo",
          "description": meta.description,
          "address": {
            "@type": "PostalAddress",
            "addressCountry": "IT",
            "addressRegion": "Sardegna"
          },
          "url": baseUrl,
          "image": `${baseUrl}/images/featured.jpg`
        })}
      </script>
    </Helmet>
  );
};

export default SEOHead;
